module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_max_blue.7cffe084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_max_blue.png
// module id = 2100
// module chunks = 0